var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_20552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08209 1.75841C5.1468 0.972725 3.75331 1.08566 3.04361 2.08077C2.85407 2.34657 2.62944 2.66359 2.24153 3.15002C0.907001 4.82336 0.907 7.24632 2.24893 8.91373C3.23948 10.1446 4.27824 11.3867 5.43931 12.5505C6.60043 13.7144 7.83955 14.7556 9.06757 15.7485C10.7311 17.0936 13.1483 17.0936 14.8177 15.7559C15.3355 15.341 15.6585 15.1149 15.9327 14.9186C16.8917 14.2322 17.026 12.8857 16.2772 11.9736C15.6855 11.2529 15.0266 10.5653 14.391 9.89413C13.8846 9.35948 13.039 9.32454 12.4643 9.78457C12.3098 9.90831 12.1179 10.0714 11.7287 10.437C9.81917 9.29967 8.66185 8.12545 7.54784 6.24628C7.91707 5.8515 8.07991 5.65857 8.20442 5.50214C8.66257 4.92656 8.62856 4.08115 8.092 3.57821C7.43806 2.96526 6.77254 2.33843 6.08209 1.75841Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_20552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportLine);
export default __webpack_public_path__ + "static/media/support_line.9df82316dc526c2cb23dc97c0b166284.svg";
export { ForwardRef as ReactComponent };